import { render } from "./propertiesList.vue?vue&type=template&id=aa242e6a"
import script from "./propertiesList.vue?vue&type=script&lang=js"
export * from "./propertiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__